import { title, mrAuto, mlAuto } from "assets/jss/material-kit-pro-react.jsx";
import { grayColor } from '../../../material-kit-pro-react';

const filtersStyle = {
  mrAuto,
  mlAuto,
  section: {
    padding: "70px 0"
  },
  title: {
    ...title,
    marginBottom: "1rem",
    marginTop: "30px",
    minHeight: "32px",
    textDecoration: "none",
    textAlign: "center"
  },
  description: {
    color: "#999",
    textAlign: "center"
  },
  textCenter: {
    textAlign: "center"
  },
  textArea: {
    marginRight: "15px",
    marginLeft: "15px"
  },
  priceSlider: {
    color: grayColor
  },
  textLeft: {
    textAlign: "left"
  },
  pullRight: {
    float: "right"
  },
};

export default filtersStyle;



// WEBPACK FOOTER //
// ./src/assets/jss/material-kit-pro-react/views/landingPageSections/filtersStyle.jsx